import React, { useEffect, useRef, useState } from 'react'
import image from "../../img/profiles/avatar-06.jpg"
import image2 from "../../img/gallery/gallery-01.jpg"
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ChatService from '../../../redux-toolkit/services/chatService/chatService'
import { useGetSingleAdminDataQuery } from '../../../redux-toolkit/services/AdminApi/AdminApi'
import { setOnlineUsers, updateUserAllMessageSeen, UserSingleMessageSeenUpdate } from '../../../redux-toolkit/features/slices/chatSlice/chatSlice'
import { useGetSingleUserByIdQuery } from '../../../redux-toolkit/services/UserApi/UserApi'
import axios from 'axios'
import { useDeleteAllMessageMutation, useDeleteMessageMutation, useGetChatDataQuery, } from '../../../redux-toolkit/services/ChatApi/ChatApi'
import { SingleItem } from './SingleItem';
import { formatMessengerTime } from '../../Utils/formatMessengerTime/formatMessengerTime';
import { DeleteConfirmFun, DeleteConfirmResults } from '../../Utils/Common/ToastMessage/ToastMessage';
import ImageModal from './ImageModal';
import { GrAttachment } from "react-icons/gr";
import { LuSendHorizontal } from "react-icons/lu";
import { IoClose } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import "./ChatMessage.css";
import { LiaArrowAltCircleLeftSolid } from "react-icons/lia";
import JoditEditor from "jodit-react";
import ImageUploadProgress from '../../Utils/ImageUploadProgress/ImageUploadProgress'

const ChatMessage = () => {
    const { id } = useParams();

    const dispatch = useDispatch();

    const { AuthInfo } = useSelector((state) => state?.auth);

    const { data: singleUserData, isFetching, error: UserDataError, isLoading: UserDataisLoading } = useGetSingleUserByIdQuery(id);

    const { onlineUsers, typingInfo, adminTypingInfo } = useSelector((state) => state?.chat);


    const isTyping = Array.isArray(typingInfo) && typingInfo.includes(singleUserData?.data?.email);

    const OnlineUsersStatus = onlineUsers?.some(
        user => {
            if (user?.email && singleUserData?.data?.email) {
                return user?.email?.trim().toLowerCase() === singleUserData?.data?.email?.trim().toLowerCase();
            }
            return false;
        }
    );

    const adminTypingInfoStatus = adminTypingInfo?.find(user => {
        if (user?.userEmail && singleUserData?.data?.email) {
            return user.userEmail.trim().toLowerCase() === singleUserData?.data?.email.trim().toLowerCase();
        }
        return false;
    });

    const { data: singleAdminData, error, isLoading } = useGetSingleAdminDataQuery(adminTypingInfoStatus?.adminEmail);


    useEffect(() => {
        ChatService.pair(AuthInfo?.email, singleUserData?.data?.email);
    }, [AuthInfo, onlineUsers, OnlineUsersStatus, singleUserData]);


    const [messages, setMessages] = useState([]);
    const bottomRef = useRef(null);

    useEffect(() => {
        if (id) {
            setMessages([]);
        }
    }, [id]);

    // First load → invisible instant scroll
    const [ScrollMessage, setScrollMessage] = useState([]);
    useEffect(() => {
        requestAnimationFrame(() => {
            bottomRef.current?.scrollIntoView({ behavior: "auto" });
        });
    }, [ScrollMessage]);

    // New messages → smooth scroll
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [ScrollMessage, isTyping, adminTypingInfoStatus]);



    // optional use
    useEffect(() => {
        // Online users
        ChatService.listen("onlineUsers", (onlineUsers) => {
            // console.log("onlineUsers", onlineUsers)
            if (Array.isArray(onlineUsers) && onlineUsers.length !== 0) {
                dispatch(setOnlineUsers({ data: onlineUsers, type: "onlineUsers" }));
            }
        });

        // New user
        ChatService.listen("newUser", (newOnlineUsers) => {
            // console.log("newOnlineUsers", newOnlineUsers)
            if (newOnlineUsers) {
                dispatch(setOnlineUsers({ data: newOnlineUsers, type: "newOnlineUsers" }));
            }
        });


        // Message receive
        ChatService.listenMessage((data) => {
            const newData = data?.message;
            if (newData.userId?._id === id) {
                setMessages(prev => {
                    if (prev.some(m => m._id === newData._id)) {
                        return prev;
                    }

                    return [...prev, newData];
                });
                // if (!newData?.adminId) {
                // }
                dispatch(UserSingleMessageSeenUpdate(newData));
                setScrollMessage(newData);
            }

            if (!newData?.adminId) {
                ChatService.sendMessageSeen({
                    UserId: id,
                    type: "admin"
                });
            }

        });


        // listenMessageSeen receive
        ChatService.listenMessageSeen(({ user, type }) => {

            if (!user?.lastMessage?.adminId) {
                dispatch(updateUserAllMessageSeen(user));
            }
            const lastMessage = user?.lastMessage;
            // console.log(lastMessage)
            if (lastMessage && messages) {
                setMessages(prev => {
                    if (!Array.isArray(prev)) return prev;
                    const idx = prev.findIndex(m => m?._id === lastMessage._id);
                    if (idx === -1) return prev;

                    // replace
                    const updated = [...prev];
                    updated[idx] = lastMessage;
                    return updated;
                });
            }
        });

        return () => {
            ChatService.remove("onlineUsers");
            ChatService.remove("newUser");
            ChatService.remove("messageSeenUpdate");
            ChatService.removeMessageListener();
            ChatService.removeMessageSeenListen();
        };
    }, []);


    useEffect(() => {
        ChatService.sendMessageSeen({
            UserId: id,
            type: "admin"
        });
    }, [id]);


    const typingTimeout = useRef(null);
    const [typingData, setTypingData] = useState('')
    const typingDataRef = useRef(null);

    const handleTyping = () => {
        const value = typingData;
        if (value) {

            ChatService.typing({ adminEmail: AuthInfo?.email, userEmail: singleUserData?.data?.email, type: "admin" });

            if (typingTimeout.current) {
                clearTimeout(typingTimeout.current);
            }

            typingTimeout.current = setTimeout(() => {
                ChatService.stopTyping({ adminEmail: AuthInfo?.email, userEmail: singleUserData?.data?.email, type: "admin" });
                typingTimeout.current = null;
            }, 1000);
        } else {
            ChatService.stopTyping({ adminEmail: AuthInfo?.email, userEmail: singleUserData?.data?.email, type: "admin" });
            if (typingTimeout.current) {
                clearTimeout(typingTimeout.current);
                typingTimeout.current = null;
            }
        }
        // setTypingData(value);
        // e.target.style.height = "42px";
        // e.target.style.height = `${e.target.scrollHeight}px`;
    };



    ////////////////////////////////////////// send message 

    const [images, setImages] = useState([]);
    const fileInputRef = useRef(null);
    const [previews, setPreviews] = useState([]);
    const formRef = useRef(null);




    ///////////////////////   


    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        // console.log(selectedFiles)

        const newFiles = selectedFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setPreviews((prev) => [...prev, ...newFiles]);
        setImages((prev) => [...prev, ...selectedFiles]);
        e.target.value = "";
    };

    const removeFile = (index) => {
        setPreviews((prev) => {
            const item = prev[index];

            if (item?.preview) {
                URL.revokeObjectURL(item.preview);
            }

            return prev.filter((_, i) => i !== index);
        });

        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    const clearPreviews = () => {
        setPreviews((prev) => {
            prev.forEach((item) => {
                if (item?.preview) {
                    URL.revokeObjectURL(item.preview);
                }
            });

            return [];
        });

        setImages([]);
    };





    const [ReplyData, setReplyData] = useState({});

    const handleReply = (data) => {
        setReplyData(data)
    };

    const sendMessage = async (e) => {
        if (!typingData.trim() && images.length === 0) return;

        let uploadedUrls = [];

        if (images.length > 0) {
            const formData = new FormData();
            images.forEach((img) => {
                formData.append("images", img);
            });

            try {

                ImageUploadProgress.show();

                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/upload-images`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        onUploadProgress: (progressEvent) => {
                            if (!progressEvent.total) return;
                            const percent = Math.round(
                                (progressEvent.loaded * 100) /
                                progressEvent.total
                            );
                            ImageUploadProgress.update(percent, images);
                        },
                    }
                );

                if (res?.status === 200) {
                    uploadedUrls = res.data.urls;
                    clearPreviews();
                    ImageUploadProgress.success(
                        `${images.length} ${images.length === 1 ? "image" : "images"} uploaded successfully!`
                    );
                }

            } catch (error) {
                console.error("Upload failed:", error);
                ImageUploadProgress.error(
                    "Unable to upload images. Please try again."
                );
            }
        }

        ChatService.sendMessage({
            senderId: AuthInfo?._id,
            userId: singleUserData?.data?._id,
            receiverEmail: singleUserData?.data?.email,
            from: AuthInfo?.email,
            to: singleUserData?.data?.email,
            text: typingData,
            image: uploadedUrls,
            replyId: ReplyData?._id,
            type: "admin",
        });


        setTypingData("");
        setReplyData({});
    }

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!typingData.trim() && images?.length <= 0) return;
            await sendMessage();
        }
    }




    const handleSendMessage = async (e) => {
        e.preventDefault();
        await sendMessage();
    }




    /////////////////////////////////////////////////////////////////////////////













    const [page, setPage] = useState(1);

    const { data: chatData, error: chatDataError, isLoading: ChatDataisLoading } = useGetChatDataQuery({
        userId: singleUserData?.data?._id,
        page,
    },
        { refetchOnMountOrArgChange: true });


    // Pagination buttons
    const handleNext = () => {
        if (page < chatData.totalPages) setPage(prev => prev + 1);
    };

    // Merge new page data with previous messages
    useEffect(() => {
        if (chatData?.data?.length) {
            setMessages((prev) => [...chatData.data, ...prev]);
        }
    }, [chatData]);

    useEffect(() => {
        if (chatData?.data?.length) {
            setScrollMessage([...chatData.data]);
        }
    }, [ChatDataisLoading]);


    const [DeleteMessage, { isLoading: BtnDeleteDis }] =
        useDeleteMessageMutation();


    const handleDelete = async (id) => {
        const result = await DeleteMessage(id).unwrap();
        if (result?.success) {
            setMessages((prev) => prev.filter((msg) => msg._id !== id));
        }
    }

    const [deleteAllMessage, { isLoading: DeleteisLoading }] =
        useDeleteAllMessageMutation();

    const handleAllDelete = async () => {
        try {
            if (singleUserData?.data?._id) {
                const DeleteConfirm = await DeleteConfirmFun();
                if (DeleteConfirm?.isConfirmed) {
                    const result = await deleteAllMessage(singleUserData?.data?._id).unwrap();
                    if (result?.success) {
                        setMessages([]);
                    }
                }
                DeleteConfirmResults(DeleteConfirm);
            }

        } catch (err) {
            //   toast.error(err?.data?.message || "Delete failed");
        }
    };



    const [modalShow, setModalShow] = useState(false);
    const [imageData, setImageData] = useState();

    const HandleShowImage = (data) => {
        setImageData(data)
        setModalShow(true);

    }





    const navigate = useNavigate();


    if (UserDataisLoading || isFetching || DeleteisLoading) {
        return <></>;
    }

    return (
        <>

            <ImageModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                imageData={imageData}
            />

            <section className='live-chat-message-section'>

                <header className='live-chat-message-header'>
                    <div className="customer-support-section">

                        <div className="back-url">
                            <button onClick={() => navigate(-1)}> <LiaArrowAltCircleLeftSolid />  </button>
                        </div>

                        <img src={
                            singleUserData?.data?.picture
                                ? `${process.env.REACT_APP_Authorized_API_URL}/${singleUserData?.data?.picture}`
                                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                        }
                            onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="" />
                        <h4>{singleUserData?.data?.fname} {singleUserData?.data?.lname}</h4>
                    </div>
                </header>

                <section className='chat-messages-section'>
                    {/* Message Area */}

                    {chatData?.data?.length !== 0 && chatData?.page !== chatData?.totalPages && (<div className="chat-line" >
                        <span className="chat-date" onClick={handleNext}
                        >More</span>
                    </div>)}

                    {messages?.length !== 0 ? (
                        messages?.map((data, index) => {
                            if (data) {
                                return (
                                    <SingleItem
                                        data={data}
                                        index={index}
                                        key={index}
                                        handleReply={handleReply}
                                        handleDelete={handleDelete}
                                        HandleShowImage={HandleShowImage}
                                    ></SingleItem>
                                );
                            }
                        })
                    ) : (

                        <div className='chat-message-emtry'>
                            Data not found
                        </div>
                    )}


                    {isTyping && <>
                        <div className="chat-messages">
                            <div className="messages-left">
                                <div className="user-avater">
                                    <img src={
                                        singleUserData?.data?.picture
                                            ? `${process.env.REACT_APP_Authorized_API_URL}/${singleUserData?.data?.picture}`
                                            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                                    }
                                        onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="" />
                                </div>

                                <div className="message-area">
                                    <div className="user-name">
                                        <p>{singleUserData?.data?.fname} {singleUserData?.data?.lname}</p>
                                    </div>
                                    <div className="message">
                                        <span className="typing-dot">is typing
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                        </span>

                                    </div>

                                </div>


                            </div>
                        </div>

                    </>}

                    {adminTypingInfoStatus && singleAdminData?.data && <>
                        <div className="chat-messages">
                            <div className="messages-right">
                                <div className="user-avater">
                                    <img src={
                                        singleAdminData?.data?.picture
                                            ? `${process.env.REACT_APP_Authorized_API_URL}/${singleAdminData.data.picture}`
                                            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                                    }
                                        onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="" />
                                </div>
                                <div className="message-area">
                                    <div className="message">
                                        <div className="user-name">
                                            <p>{singleAdminData?.data?.name} ({singleAdminData?.data?.role})</p>
                                        </div>
                                        <span className="typing-dot">{singleAdminData?.data?.name} is typing
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                        </span>


                                    </div>

                                </div>
                                <div className="user-avater">
                                    <img src="https://embed.tawk.to/_s/v4/assets/images/default-profile.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </>}

                    <div ref={bottomRef} ></div>

                </section>

                <footer>
                    <form onSubmit={handleSendMessage} ref={formRef} className='chat-input-form-area'>
                        {/* Image Preview */}
                        {previews.length > 0 && (
                            <div className="image-preview-section">

                                {previews.map((item, index) => (
                                    <div className="image-preview" key={index}>
                                        <img src={item.preview} alt="preview" />

                                        <button
                                            type="button"
                                            className="remove-image"
                                            onClick={() => removeFile(index)}
                                        >
                                            <IoClose size={14} />
                                        </button>
                                    </div>
                                ))}

                                {/* Add More */}
                                <button
                                    type="button"
                                    className="add-image"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <FiPlus size={30} />
                                </button>

                            </div>
                        )}

                        <section className='chat-input-secton'>
                            <div className="chat-input-left">
                                {/* <textarea name="" id=""></textarea> */}

                                <div className="form">

                                    <JoditEditor
                                        ref={typingDataRef}
                                        value={typingData}
                                        height="600"
                                        onChange={(newContent) => {
                                            setTypingData(newContent);
                                            handleTyping();
                                        }}
                                    />

                                    {/* <textarea
                                        value={typingData}
                                        onChange={handleTyping}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Type here and press enter.."
                                        className="input textarea"
                                    /> */}
                                </div>
                            </div>

                            <div className="chat-input-right">

                                <div className="file-input-are">
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                    />

                                    <GrAttachment
                                        size={20}
                                        className="attachment-icon"
                                        onClick={() => fileInputRef.current?.click()}
                                    />
                                </div>
                                <div className="send-btn">
                                    <button type='submit'> <LuSendHorizontal /></button>
                                </div>


                            </div>


                        </section>
                    </form>


                </footer>


            </section>


        </>
    )
}

export default ChatMessage;